import React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import Landing from "./Landing"
import LactationServices from "./LactationServices"
import Missing from "./Errors/Missing"
import PostpartumConsultation from "./PostpartumConsultation"
import PrenatalConsultation from "./PrenatalConsultation"
import WeightCheck from "./WeightCheck"
import Forms from "./Forms"
import Contact from "./Contact"
import Terms from "./Terms"
import Privacy from "./Privacy"

require("base.css")

export default function AppRoot() {
  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route
            path="/breastfeeding-support/in-home-consultation"
            component={PostpartumConsultation}
          />
          <Route
            path="/breastfeeding-support/prenatal-consultation"
            component={PrenatalConsultation}
          />
          <Route path="/breastfeeding-support/weight-check" component={WeightCheck} />
          <Route path="/breastfeeding-support" component={LactationServices} />
          <Route path="/forms" component={Forms} />
          <Route path="/contact" component={Contact} />

          <Route path="/terms" component={Terms} />
          <Route path="/privacy" component={Privacy} />

          <Route exact path="/" component={Landing} />
          <Route component={Missing} />
        </Switch>
      </Router>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/views/pages/index.js